import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { Observable } from 'rxjs/Observable';

const CACHE_TIME: number = 3600;

export class BasicServerPlugin extends SmartenitPlugin {
  get stateTTL(): number {
    return CACHE_TIME;
  }

  get hardwareVersion(): string {
    return this.state.hardwareVersion;
  }

  get softwareVersion(): string {
    if (
      this.state.applicationVersion != null &&
      this.state.stackVersion != null
    ) {
      return [this.state.applicationVersion, this.state.stackVersion].join('-');
    } else if (this.state.applicationVersion != null) {
      return this.state.applicationVersion;
    } else if (this.state.stackVersion != null) {
      return this.state.stackVersion;
    } else {
      return '-';
    }
  }

  public getHardwareVersion() {
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'HWVersion',
      null,
      false,
      `cacheTTL=${this.stateTTL}`
    );
  }

  public getSoftwareVersion() {
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'ApplicationVersion',
      null,
      false,
      `cacheTTL=${this.stateTTL}`
    );
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      'StackVersion',
      null,
      false,
      `cacheTTL=${this.stateTTL}`
    );
  }

  public getStatusPayload(): any {
    return ['HWVersion', 'ApplicationVersion', 'StackVersion'];
  }

  public getStatus(
    context?: string,
    force?: boolean,
    asObservable?: boolean,
    payload?: any,
    sendDirect: boolean = false
  ) {
    if (payload && Object.keys(payload).length > 0) {
      payload = Object.assign(this.getStatusPayload(), payload);
    } else {
      payload = this.getStatusPayload();
    }

    this.device.getStatus(
      this.componentId,
      this.processorName,
      payload,
      'cached=false',
      sendDirect
    );
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;

    if (attribute === 'HWVersion') {
      this.state.hardwareVersion =
        response.value != null ? response.value : '-';

      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'ApplicationVersion') {
      this.state.applicationVersion =
        response.value != null ? response.value : '-';

      this._onUpdate.next({ state: this.state });
    } else if (attribute === 'StackVersion') {
      this.state.stackVersion = response.value != null ? response.value : '-';

      this._onUpdate.next({ state: this.state });
    }

    return this.state;
  }
}
